import { render, staticRenderFns } from "./ywzl_details.vue?vue&type=template&id=75b41edf&scoped=true&"
import script from "./ywzl_details.vue?vue&type=script&lang=js&"
export * from "./ywzl_details.vue?vue&type=script&lang=js&"
import style0 from "./ywzl_details.vue?vue&type=style&index=0&id=75b41edf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b41edf",
  null
  
)

export default component.exports